// extracted by mini-css-extract-plugin
export default {"icono":"NoticiasEventosCardHome_icono__mcZ4t","cardBg":"NoticiasEventosCardHome_cardBg__LQ9kR"};